import { Controller } from "@hotwired/stimulus"

// Saves the gift note when the field loses focus (the « Enregistrer » button stays for no-JS)
// and keeps the character counter in step. No optional chaining (Webpacker 5).
export default class extends Controller {
  static targets = ["field", "counter", "submit"]

  connect() {
    this.saved = this.fieldTarget.value
    if (this.hasSubmitTarget) this.submitTarget.hidden = true
  }

  count() {
    if (this.hasCounterTarget) {
      this.counterTarget.textContent = this.fieldTarget.value.length + "/" + this.fieldTarget.maxLength
    }
  }

  save() {
    if (this.fieldTarget.value === this.saved) return

    this.pending = this.fieldTarget.value
    this.element.requestSubmit()
  }

  // The note counts as saved only once the server accepted it, so a failed request is retried on the next blur.
  submitted(event) {
    if (event.detail.success) this.saved = this.pending
  }
}
